<div class="backdrop" (click)="close()"></div>
<div class="chatWrapper">
    <div class="chatInner">
      <div class="heading flex justify-content-between">
        <h1>Items in Cart</h1>
        <span class="close" (click)="close()"> <lucide-icon name="X" class="close_icon"></lucide-icon> </span>
      </div>
      <div class="quick-cart">
        
        <div *ngIf="cartItems?.length; else noProduct">
          <div class="flex product" *ngFor="let product of cartItems">
            <span class="product-image">
              <img [src]="product.imageUrl" alt="" srcset="" />
            </span>
            <div class="product-name">
              <h3 title="{{ product.productName }}">{{ product.productName }}</h3>
              <div class="quatity_box">
                <button
                  [disabled]="product?.quantity <= 0"
                  class="number minus"
                  (click)="minusQuantity(product.productId)"
                >
                  <lucide-icon
                    name="minus"
                    [size]="18"
                    class="lucid-icon"
                  ></lucide-icon>
                </button>
                <span class="quantity-input"
                  ><input
                    type="number"
                    name=""
                    [value]="product?.quantity"
                    (change)="inputQuantity(product.productId, $event)"
                /></span>
                <button
                  class="number plus"
                  (click)="addQuantity(product.productId)"
                >
                  <lucide-icon
                    name="plus"
                    [size]="18"
                    class="lucid-icon"
                  ></lucide-icon>
                </button>
              </div>
              <p *ngIf="cartItemsError.has(product.productId)" class="errorTxt">
                Invalid quantity
              </p>
            </div>
            <span class="removeProduct" (click)="removeProduct(product.productId)">
              <lucide-icon name="trash" color="#666" class="my-icon" [size]="20"></lucide-icon>
            </span>
          </div>
        </div>
      </div>
      <div class="btn_row flex" *ngIf="cartItems?.length">
        <button
          mat-button
          (click)="nevigateCheckout()"
          color="primary"
          type="button"
          class="btnCustom btn-primary"
        >
          Raise RFQ
        </button>
      </div>
      <ng-template #noProduct>
        <div class="epmtyCart">
          <div class="wrappCart">
              <lucide-icon
            name="shopping-basket"
            class="my-icon fileIco"
            [size]="100"
            color="#DA2129"
            ></lucide-icon>
            <h3 class="medium font-18">Your Cart is currently empty!</h3>
            <p class="empty-cart">Must add item in cart before you proceed to Raise RFQ</p>
          </div>
        </div>
      </ng-template>
    </div>
</div>
